import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// 新站内容包（cy 命名空间）：英文全量，中文全量（P0 已补齐），键名一一对应。
// 旧的 translation.json（含已禁用的规模/回报主张与模板文案）不再加载。
import cyEN from './content/en';
import cyZH from './content/zh';
import { getLanguageFromPath } from './lib/languagePaths';

// 语言由 URL 决定（/zh 前缀 → 中文，否则英文），而非浏览器设置。
// 这使每个 URL 都指向确定语言的页面，语言切换通过全页跳转完成（爬虫友好）。
const getUrlLanguage = () => {
  if (typeof window === 'undefined') return 'en';
  return getLanguageFromPath(window.location.pathname);
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { cy: cyEN },
      zh: { cy: cyZH }
    },
    lng: getUrlLanguage(),
    fallbackLng: "en",
    ns: ['cy'],
    defaultNS: 'cy',

    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('language', lng);
  } catch (_) { /* 隐私模式下写入可能失败，忽略 */ }
});

export default i18n;
